import React, { useState } from "react";
import PostResume from '../components/blog-post-resume'
import { GET_PAGINATION_BLOG } from './paginationQueryDefinition'
import { ApolloClient, InMemoryCache, HttpLink } from '@apollo/client'
import Pagination from "./pagination";

const defaultOptions = {
    watchQuery: {
        fetchPolicy: 'no-cache',
        errorPolicy: 'ignore',
    },
    query: {
        fetchPolicy: 'no-cache',
        errorPolicy: 'all',
    },
}

const BlogPosts = ({ posts, paginationInfo, site }) => {
    const [postsPerPage, setPostPerPage] = useState(posts)
    const [pagination, setPagination] = useState(paginationInfo)
    const [currentPage, setCurrentPage] = useState(pagination?.currentPage)
    const [hasPreviousPage, setHasPreviousPage] = useState(pagination?.hasPreviousPage)
    const [hasNextPage, setHasNextPage] = useState(pagination?.hasNextPage)
    const [blogsPerPage, setBlogsPerPage] = useState(15)
    const [lastPage, setLastPage] = useState(pagination?.pageCount)

    const headers = {};
    headers['Ocp-Apim-Subscription-Key'] = process.env.GATSBY_API_MANAGMENT_KEY;

    const client = new ApolloClient({
        link: new HttpLink({ uri: `${process.env.GATSBY_BOOKABLE_SEARCH_API}`,headers: headers}),
        cache: new InMemoryCache(),
        defaultOptions: defaultOptions,
    })

    // click en un boton de el paginador (llamdado desde el next y previous tambien.)
    const makeQueryPagination = (page, tag) => {
        let vars = {
            page: page,
            limit: blogsPerPage,
            tag: tag,
            site: site
        }
        client.query({
            query: GET_PAGINATION_BLOG,
            variables: vars
        }).then(result => {
            setPostPerPage(result.data.paginationBlogDefinition.posts)
            setLastPage(result.data.paginationBlogDefinition.pageInfo.pageCount)
            setHasPreviousPage(result.data.paginationBlogDefinition.pageInfo.hasPreviousPage)
            setHasNextPage(result.data.paginationBlogDefinition.pageInfo.hasNextPage);
        })
    }

    const firstPostWithImage = postsPerPage.findIndex(post => post.image);

    return (
        <>
            <div className="posts">
                {
                    postsPerPage.map((post, i) => {
                        return (

                            <PostResume 
                                key={post.title} 
                                post={post} 
                                firstImage={post.image ? i === firstPostWithImage : false}
                            />
                        )
                    })
                }
            </div>
            <Pagination class="pagination"
                currentPage={currentPage}
                hasPreviousPage={hasPreviousPage}
                hasNextPage={hasNextPage}
                lastPage={lastPage}
                makeQueryPagination={makeQueryPagination}
                setCurrentPage={setCurrentPage}
                whoIsCalling='blogs'
            />
        </>
    )
}

export default BlogPosts